const Share = {
  init: () => {
    Share.activateBtns();
  },

  copyShareURL: (url) => {
    // copy to clipboard
    if (url) navigator.clipboard.writeText(url);
  },

  activateBtns: () => {
    // find every share btn
    const shareBtns = Array.from(document.querySelectorAll(".btn--share"));

    // find every copy share url btn
    const copyShareURLBtns = Array.from(
      document.querySelectorAll(".copy-share-url-trigger")
    );

    // activate every share btn
    if (shareBtns) {
      shareBtns.forEach((btn) => {
        if (!btn.classList.contains("btn-share-trigger")) {
          btn.classList.add("btn-share-trigger");

          btn.addEventListener("click", function () {
            let expanded =
              this.getAttribute("aria-expanded") === "true" || false;
            this.setAttribute("aria-expanded", !expanded);
          });
        }
      });
    }

    // activate copy share url btns
    if (copyShareURLBtns) {
      copyShareURLBtns.forEach((btn) => {
        btn.addEventListener("click", function () {
          const shareURL = this.dataset.shareUrl;
          if (shareURL) Share.copyShareURL(shareURL);
        });
      });
    }
  },
};

export default Share;
